import React from 'react';
import { Gutter, Input, Layout, LayoutItem, Radio, Tooltip } from '@axiom/ui';
import type { OpportunityCandidate } from '@axiom/validation';

import type { OpportunitySubmissionCandidateRateFieldToCalculateType } from './opportunity-submission-candidate-rate-schema';
import { OpportunitySubmissionCandidateRateUtil } from './opportunity-submission-candidate-rate-util';

export type OpportunitySubmissionCandidateRateInputProps = {
  opportunityCandidate: OpportunityCandidate;
  disabled?: boolean;
  fieldName: OpportunitySubmissionCandidateRateFieldToCalculateType;
  fieldToCalculate: OpportunitySubmissionCandidateRateFieldToCalculateType;
  label: React.ReactNode;
  onChange: (value: number | string | null | undefined) => Promise<unknown>;
  readOnly: boolean;
  tooltip?: React.ReactNode;
};

export const OpportunitySubmissionCandidateRateInput = ({
  opportunityCandidate,
  disabled,
  fieldName,
  fieldToCalculate,
  label,
  onChange,
  readOnly,
  tooltip,
}: OpportunitySubmissionCandidateRateInputProps) => {
  const cpqTargetsUnavailable =
    OpportunitySubmissionCandidateRateUtil.isCpqTargetsUnavailable({
      opportunityCandidate,
    });
  const isDisabledState =
    OpportunitySubmissionCandidateRateUtil.isDisabledState({
      opportunityCandidate,
    });

  return (
    <Layout position="middle left">
      {readOnly || cpqTargetsUnavailable ? null : (
        <LayoutItem rightGutter="16px" name={`${fieldName}-radio`}>
          <Radio name="fieldToCalculate" option={fieldName} />
        </LayoutItem>
      )}
      <LayoutItem fluid>
        <Input
          disabled={
            readOnly ||
            isDisabledState ||
            fieldToCalculate === fieldName ||
            cpqTargetsUnavailable ||
            disabled
          }
          label={label}
          name={fieldName}
          onChange={onChange}
          Tooltip={
            tooltip ? (
              <Gutter left="16px">
                <Tooltip>{tooltip}</Tooltip>
              </Gutter>
            ) : undefined
          }
        />
      </LayoutItem>
    </Layout>
  );
};
